import { Typography } from "@material-ui/core"

const Base = (props) => {

  return ( <>
    <Typography>
    Easy! When you purchase your custom song, you’ll schedule your video call with a lyricist right then and there. No back-and-forth emails, no waiting—just pick a time that works for you, and we’ll be ready to chat about your song!
    </Typography>
  </> )
}

export default Base
